import PropTypes from 'prop-types';
import React from 'react';
import { SvgIcon } from '@mui/material';
import { white } from '../../colors';

export default function Activity(props) {
    const { fill = white, ...rest } = props;

    return (
        <SvgIcon fontSize="large" viewBox="0 0 24 24" {...rest}>
            <path
                d="M22 12H18L15 21L9 3L6 12H2"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </SvgIcon>
    );
}

Activity.propTypes = {
    fill: PropTypes.string,
};
